/**
 * Каркас экрана: безопасные отступы, заголовок, место под таб-бар.
 *
 * Все экраны обязаны использовать его — иначе на iPhone заголовок уезжает
 * под «чёлку», а последний элемент списка прячется за таб-баром.
 *
 * Заголовок лежит на «небе дня» — тёплой заливке, которая меняется от утра
 * к ночи. Содержимое проявляется каскадом сверху вниз: экран собирается на
 * глазах, а не вспыхивает целиком.
 */

import clsx from 'clsx'
import type { ReactNode } from 'react'

import { TimeSky } from '@/shared/ui/decor'

export function Screen({
  title,
  subtitle,
  right,
  children,
  className,
  withTabBar = true,
}: {
  title?: ReactNode
  subtitle?: ReactNode
  right?: ReactNode
  children: ReactNode
  className?: string
  withTabBar?: boolean
}) {
  return (
    // Ширина ограничена: Telegram Desktop открывает мини-апп в широком окне,
    // и растянутый на 1200px мобильный макет выглядит сломанным.
    <div
      className={clsx(
        'pt-safe relative mx-auto min-h-full w-full max-w-[520px]',
        withTabBar ? 'pb-tabbar' : 'pb-safe',
      )}
    >
      <TimeSky />

      {title && (
        <header className="enter relative flex items-end justify-between gap-3 px-4 pt-5 pb-6">
          <div className="min-w-0">
            <h1 className="font-display truncate text-screen leading-[1.15]">{title}</h1>
            {subtitle && (
              <p className="font-hand text-text-muted mt-1 truncate text-lead leading-tight">
                {subtitle}
              </p>
            )}
          </div>
          {right && <div className="shrink-0 pb-1">{right}</div>}
        </header>
      )}

      <main className={clsx('stagger relative space-y-3.5 px-4', className)}>{children}</main>
    </div>
  )
}
